module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "primary": ""
          }
        }, on), [_vm._v("Add")])]
      }
    }]),
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Add Parcel Number Range")])]), _vm._v(" "), _c('v-card-text', [_c('v-alert', [_vm._v(_vm._s(_vm.addParcelNumberRangeError))]), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.types,
      "filled": "",
      "label": "Type"
    },
    model: {
      value: (_vm.pnr_type),
      callback: function($$v) {
        _vm.pnr_type = $$v
      },
      expression: "pnr_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Start Number",
      "required": "",
      "counter": _vm.getType(_vm.pnr_type).min,
      "rules": [_vm.validateRequired('pnr_startNumber'), _vm.validateLength('pnr_startNumber', _vm.getType(_vm.pnr_type).min)],
      "type": "number"
    },
    model: {
      value: (_vm.pnr_startNumber),
      callback: function($$v) {
        _vm.pnr_startNumber = $$v
      },
      expression: "pnr_startNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "End Number",
      "required": "",
      "counter": _vm.getType(_vm.pnr_type).min,
      "rules": [_vm.validateRequired('pnr_endNumber'), _vm.validateLength('pnr_endNumber', _vm.getType(_vm.pnr_type).min)],
      "type": "number"
    },
    model: {
      value: (_vm.pnr_endNumber),
      callback: function($$v) {
        _vm.pnr_endNumber = $$v
      },
      expression: "pnr_endNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Depot",
      "type": "number"
    },
    model: {
      value: (_vm.pnr_depo),
      callback: function($$v) {
        _vm.pnr_depo = $$v
      },
      expression: "pnr_depo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Service",
      "type": "text"
    },
    model: {
      value: (_vm.pnr_service),
      callback: function($$v) {
        _vm.pnr_service = $$v
      },
      expression: "pnr_service"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "hint": "",
      "label": "Parcel Number Container Id",
      "disabled": ""
    },
    model: {
      value: (_vm.pnr_parcelnumberContainerId),
      callback: function($$v) {
        _vm.pnr_parcelnumberContainerId = $$v
      },
      expression: "pnr_parcelnumberContainerId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('small', [_vm._v("*indicates required field")])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addParcelNumberRange()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formReset()
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "options": _vm.pagination,
      "server-items-length": _vm.totalItems,
      "loading": _vm.loading,
      "footer-props": _vm.footerProps
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      },
      "update:items-per-page": _vm.getItemPerPage
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.startNumber))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.endNumber))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.state))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.service))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.size))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.size - item.consumed + item.reserved))])])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-0628c5b6"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/GetParcelNumberRange.vue
// module id = 916
// module chunks = 1